import InfoBlock from "./Info";

export default InfoBlock;